import { useMobile } from '@/composables/mobile'

export default {
  computed: {
    isMobile(): boolean {
      return useMobile().isMobile.value
    },
  },
}
